/* ==========================================================================
   Custom.js (Gecko / The4 safe wrapper + Hero Flickity mobile disable)
   ========================================================================== */

(function () {
  'use strict';

  function with$Ready(cb, tries) {
    tries = tries || 0;
    var $ = window.jQuery_T4NT || window.jQuery;
    if (!$) {
      if (tries > 60) return;
      return setTimeout(function () { with$Ready(cb, tries + 1); }, 50);
    }
    $(function () { cb($); });
  }

  with$Ready(function ($) {
    $(document).on("variant:changed", function (evt) {});

    $(document).on('click', '.t4s-viewall-demos-btn', function () {
      if ($ && $.magnificPopupT4s && typeof $.magnificPopupT4s.open === 'function') {
        $.magnificPopupT4s.open({
          items: { src: '#t4s-theme__demo', type: 'inline' }
        });
      }
    });
  });
})();

(function () {
  'use strict';

  const BP = 749;
  const HERO_ID = 'shopify-section-template--27363546824785__1646028739ae283905';

  function isMobile() {
    return window.matchMedia(`(max-width:${BP}px)`).matches;
  }

  function applyFix() {
    if (!isMobile()) return;

    const root = document.getElementById(HERO_ID);
    if (!root) return;

    const slider = root.querySelector('.flickityt4s-slider');
    if (!slider) return;

    if (!root.classList.contains('t4s-hero-flickity-disabled-mb')) {
      root.classList.add('t4s-hero-flickity-disabled-mb');
    }

    try {
      const flkty =
        (window.Flickity && typeof window.Flickity.data === 'function')
          ? window.Flickity.data(slider)
          : (slider._flickity || slider.flickity || null);

      if (flkty && typeof flkty.destroy === 'function') flkty.destroy();
    } catch (e) {}

    slider.querySelectorAll('.t4s-slideshow-item').forEach((s, i) => {
      s.style.display = i === 0 ? '' : 'none';
    });

    slider.style.transform = 'none';
    slider.style.left = 'auto';

    if (!document.querySelector('style[data-hero-flickity-fix="1"]')) {
      const css = `
@media (max-width:${BP}px){
  #${HERO_ID}.t4s-hero-flickity-disabled-mb .flickityt4s-page-dots{display:none!important;}
  #${HERO_ID}.t4s-hero-flickity-disabled-mb .flickity-prev-next-button,
  #${HERO_ID}.t4s-hero-flickity-disabled-mb .flickityt4s-prev-next-button{display:none!important;}
  #${HERO_ID}.t4s-hero-flickity-disabled-mb .flickityt4s-slider{
    min-height:350px;overflow:hidden;transform:none!important;left:auto!important;
  }
}`;
      const style = document.createElement('style');
      style.setAttribute('data-hero-flickity-fix', '1');
      style.appendChild(document.createTextNode(css));
      document.head.appendChild(style);
    }
  }

  // tek sefer: DOM + load
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', applyFix)
    : applyFix();

  window.addEventListener('load', applyFix);
})();
